import ApolloClient from 'apollo-client';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher
} from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import { galleryGraphQlUrl } from 'config';
import { createMiddlewareLink } from './middleware';
import introspectionQueryResultData from './fragmentTypes.json';

const cache = new InMemoryCache({
  fragmentMatcher: new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  })
});

const middlewareLink = createMiddlewareLink();
const httpLink = new HttpLink({
  uri: galleryGraphQlUrl,
  fetch: (uri, customOptions) => {
    // Get custom query params to add to URL from middleware
    const { urlSearchParams, ...options } = customOptions;

    if (urlSearchParams) {
      uri = `${uri}?${urlSearchParams.toString()}`;
    }

    return fetch(uri, options);
  }
});

const link = middlewareLink.concat(httpLink);

const client = new ApolloClient({
  link,
  cache: cache.restore(window.__APOLLO_STATE__ || {})
});

export default client;
